module.exports = __webpack_public_path__ + "img/note.4a5f6223.png";